module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    staticClass: "box",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "list__header"
  }, [_c('p', {
    staticClass: "list__title"
  }, [_vm._v("\n          " + _vm._s(_vm.getRouteName(_vm.$route)) + "\n        ")]), _vm._v(" "), _c('search-list-form', {
    on: {
      "submit": _vm.fetchData
    },
    model: {
      value: (_vm.filters.selected.search),
      callback: function($$v) {
        _vm.$set(_vm.filters.selected, "search", $$v)
      },
      expression: "filters.selected.search"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "list__table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.data,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-table', {
          staticClass: "list__table",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": props.row.registrations
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "id",
            "label": "id",
            "width": "80"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "email",
            "label": "email"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "imię i nazwisko"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "date_of_birth",
            "label": "data ur.",
            "width": "100"
          }
        }), _vm._v(" "), _c('el-table-column', {
          staticClass: "pull-right",
          attrs: {
            "label": "akcje",
            "width": "150"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-button', {
                attrs: {
                  "type": "danger",
                  "size": "small",
                  "title": "Usuń tę rezerwację"
                },
                on: {
                  "click": function($event) {
                    return _vm.handleDelete(scope.$index, scope.row, props.row.registrations)
                  }
                }
              }, [_c('i', {
                staticClass: "el-icon-delete"
              })])]
            }
          }], null, true)
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "id",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "event",
      "label": "wydarzenie"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "data"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "hour_from",
      "label": "godzina"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "registered_number",
      "label": "zapisanych"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "number_of_seats",
      "label": "liczba miejsc"
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "pull-right",
    attrs: {
      "label": "opcje",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "title": "Eksportuj"
          },
          on: {
            "click": function($event) {
              return _vm.downloadCSV(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-download"
        })])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "list__pagination",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.count
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3145b218"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Spectacles/RegistrationsList.vue
// module id = 736
// module chunks = 0